// {
//   "name": "iconic-rotating-bar-third.js",
//   "author": "Arham Web Works"
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get('iconic-rotating-bar-third')) return;

  class IconicRotatingBarThird extends HTMLElement {
    constructor() {
      super();
      this.lastScroll = window.scrollY;

      this.onScroll = this.onScroll.bind(this);
      this.onMouseMove = this.onMouseMove.bind(this);
    }

    connectedCallback() {
      this.sectionId = this.id.replace('iconic-rotating-bar-third-', '');

      this.marquees = this.querySelectorAll(`.iconic-marquee-${this.sectionId}`);
      this.imagesContainer = this.querySelector(`.iconic-floating-images-${this.sectionId}`);
      this.images = this.querySelectorAll(`.iconic-hover-preview-${this.sectionId}`);

      // Select texts directly
      this.texts = this.querySelectorAll(`.iconic-rotating-item-text-${this.sectionId}`);

      // Attach events
      this.texts.forEach(text => {
        text.addEventListener('mouseover', (e) => {
          this.onEnter(e, text);
        });

        text.addEventListener('mousemove', this.onMouseMove);

        text.addEventListener('mouseout', (e) => {
          if (e.relatedTarget && text.contains(e.relatedTarget)) return;
          this.onLeave();
        });
      });

      // Scroll direction logic
      this.enableDirectionChange = [...this.marquees].some(el =>
        el.classList.contains('iconic-change-direction')
      );

      if (this.enableDirectionChange) {
        this.scrollHandler = () => {
          if (this.scrollTicking) return;

          this.scrollTicking = true;

          requestAnimationFrame(() => {
            this.onScroll();
            this.scrollTicking = false;
          });
        };

        window.addEventListener('scroll', this.scrollHandler, { passive: true });
      }

      this.onScroll();
    }

    disconnectedCallback() {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
      }
    }

    // HOVER
    onEnter(e, text) {
      const id = text.dataset.id || text.getAttribute('id');
      if (!id) return;

      this.texts.forEach(t => {
        t.classList.toggle('iconic-active', t === text);
      });

      this.images.forEach(img => {
        const isActive = String(img.dataset.id) === String(id);
        img.classList.toggle('iconic-active', isActive);
      });

      if (this.imagesContainer) {
        this.imagesContainer.style.display = 'block';
        this.onMouseMove(e);
      }
    }

    onMouseMove(e) {
      if (!this.imagesContainer) return;

      this.mouseX = e.pageX;
      this.mouseY = e.pageY;

      if (this.raf) return;

      this.raf = requestAnimationFrame(() => {
        this.imagesContainer.style.transform = `translate(${this.mouseX + 10}px, ${this.mouseY + 10}px)`;
        this.raf = null;
      });
    }

    onLeave() {
      if (this.imagesContainer) {
        this.imagesContainer.style.display = 'none';
      }

      this.texts.forEach(t => t.classList.remove('iconic-active'));
      this.images.forEach(img => img.classList.remove('iconic-active'));
    }

    // SCROLL
    onScroll() {
      if (!this.marquees || this.marquees.length === 0) return;

      const current = window.scrollY;

      if (Math.abs(current - this.lastScroll) < 5) return;

      const scrollingDown = current > this.lastScroll;

      this.marquees.forEach(marquee => {
        if (!marquee.classList.contains('iconic-change-direction')) return;

        marquee.classList.toggle('iconic-direction-left', scrollingDown);
        marquee.classList.toggle('iconic-direction-right', !scrollingDown);
      });

      this.lastScroll = current;
    }
  }

  customElements.define('iconic-rotating-bar-third', IconicRotatingBarThird);
})();